import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative size-full min-h-0 touch-none **:touch-none'
  }
});
